/**
 * Map layout for the root route
 */

'use client';

import React from 'react';
import { MapProvider } from '@/contexts/map';

interface MapLayoutProps {
  children: React.ReactNode;
}

export default function MapLayout({ children }: MapLayoutProps) {
  return (
    <MapProvider>
      {children}
    </MapProvider>
  );
}
